module.exports = require("@swa-ui/personal-info/src/form/AddressFormFields/AddressFormFields.module.scss");